import {
  BurialGroundRecords,
  HealthServicesLeftMenuList,
} from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Land_Records_Burial_Grounds = () => (
  <TableStructure
    title="Land Records Of Burial Grounds"
    heading={false}
    list={BurialGroundRecords}
    columnNo={1}
    leftMenuList={HealthServicesLeftMenuList}
    longMenuList={true}
  />
);

export default Land_Records_Burial_Grounds;
